module.exports = __webpack_public_path__ + "images/emoji/umbrella.8dbbc8daf5cd649f9c7f.png";